import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { Cloudinary, CloudinaryImage } from '@cloudinary/url-gen';
import { thumbnail } from '@cloudinary/url-gen/actions/resize';

import { DeviceDetectorService } from 'ngx-device-detector';

import { CloudConfig } from '../configs/config';

@Injectable({
  providedIn: 'root',
})
export class CloudinaryService {
  private readonly breakpointsConfig = this.deviceDetectorService;
  private readonly window = this.document?.defaultView;

  constructor(
    private deviceDetectorService?: DeviceDetectorService,
    @Inject(DOCUMENT) private document?: Document,
  ) {}

  getCloudImage(
    imageUrl: string,
    isBigImage = false,
    isTripCardImg = false,
  ): string {
    if (imageUrl && imageUrl.includes('cloudinary')) {
      return imageUrl;
    }

    const cld = new Cloudinary({
      cloud: {
        cloudName: CloudConfig.cloudName,
        apiKey: CloudConfig.cloudApiKey,
        apiSecret: CloudConfig.cloudApiSecret,
      },
    });

    const img: CloudinaryImage = cld.image(imageUrl);
    img.setDeliveryType('fetch');
    img.format('auto');

    if (isBigImage) {
      this.needResizeCloudImg(img, isTripCardImg);
    }

    return img.toURL();
  }

  needResizeCloudImg(img: CloudinaryImage, isTripCardImg = false): void {
    const isMobile = !this.breakpointsConfig.isDesktop();

    if (isTripCardImg) {
      img.resize(thumbnail().width(624));
      return;
    }

    if (isMobile) {
      img.resize(thumbnail().width(426));
      return;
    }

    if (this.window) {
      const clientWidth = this.window.document.body.clientWidth;
      if (!isMobile && clientWidth < 1920) {
        img.resize(thumbnail().width(1150));
      }
    }
  }
}
